import AnimatingObserver from "../plugins/animations";

new AnimatingObserver();